<template>
    <div>
        <default-navigation navbarClass="bg-primary"></default-navigation>
        <section class="bg-primary pt-0">
            <div class="custom-container">
                <div class="row justify-content-center">
                    <div class="col-xl-8 text-center">
                        <h1>Uw onderzoek is bijna verstuurd...</h1>
                        <p class="mb-4">
                            Er is een link naar u toegestuurd om uw e-mailadres te verifi&euml;ren. Wanneer u op deze link klikt zal uw onderzoek worden verstuurd!
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'SendInquiry'
}
</script>
